import { MenuType } from "@src/@types/MenuITypes";
import { Zap, FileText, Image, CheckCircle } from "react-feather";
import { ReactComponent as GlobeIcon } from "../../assets/images/pages/globe.svg";
import { ReactComponent as NotebookIcon } from "../../assets/images/pages/Notebook.svg";
import { ReactComponent as DashboardIcon } from "../../assets/images/pages/layout-dashboard.svg";


const Menu : MenuType[]= [
  {
    id: "dashboard",
    title: "dashboard",
    icon: <DashboardIcon width={24} height={24} />,
    navLink: "/dashboard",
  },
  {
    id: "sites",
    title: "sites",
    icon: <GlobeIcon width={24} height={24} />,
    navLink: "/sites",
  },
  {
    id: "script",
    title: "installation",
    icon: <NotebookIcon width={24} height={24} />,
    navLink: "/installation",
  },
  // Section header estático — não é link nem colapsável. Serve só de rótulo
  // pra agrupar visualmente os itens de AI Content abaixo.
  {
    header: "verticalMenu.aiContent",
    icon: <Zap size={20} strokeWidth={1.5} className="me-1" />,
  },
  {
    id: "ai-content-alt",
    title: "alternativeTexts",
    icon: <FileText size={24} strokeWidth={1.5} />,
    navLink: "/ai-content/alternative-texts",
  },
  // Ocultos temporariamente ate as telas ficarem prontas.
  // {
  //   id: "ai-content-social",
  //   title: "socialImages",
  //   icon: <Image size={24} strokeWidth={1.5} />,
  //   navLink: "/ai-content/social-images",
  // },
  // {
  //   id: "ai-content-review",
  //   title: "aiContentReview",
  //   icon: <CheckCircle size={24} strokeWidth={1.5} />,
  //   navLink: "/ai-content/review",
  // },
];
export default Menu
